<template>
  <div class="position-relative">
    <CarouselWidget
      v-if="items.length"
      class="slide-show-section"
      :items="items"
      :itemsToShow="{
        xs: 1,
        sm: 1,
        md: 1,
        lg: 1,
        xl: 1,
      }"
      :gap="0"
      nav
      nav-inside
    >
      <template #item="{ item }">
        <v-card
          :href="item.link"
          :target="item.target ? '_blank' : '_self'"
          flat
          tile
        >
          <img
            :src="
              files +
              (xsOnly && item.mobile
                ? item.mobile + '?resize=1&w=600'
                : item.desktop + '?resize=1&w=1920')
            "
            class="slide-show-section_img d-block"
            width="100%"
          />
        </v-card>
      </template>
    </CarouselWidget>

    <div class="d-flex align-center informations">
      <v-container class="d-flex justify-center justify-md-end py-0">
        <v-sheet
          class="py-8 px-md-6 informations-square"
          :color="smAndDown ? 'transparent' : 'rgba(255, 255, 255, 0.25)'"
          width="360px"
        >
          <div
            class="
              white--text
              text-subtitle-1 text-md-h6 text-center
              font-weight-bold
            "
          >
            Mais Informações
          </div>
          <InformationsForm
            class="mt-6"
            :action="server + formAction"
            :responseText="responseText"
          />
        </v-sheet>
      </v-container>
    </div>
  </div>
</template>

<script>
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import InformationsForm from "../forms/InformationsForm.vue";

const _config = {
  mod: "slides",
};

const _data = {
  formAction: "/rest/email/informations",
  responseText: "Agradecemos o contato, responderemos o mais breve possível.",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.filter(({ desktop }) => !!desktop);
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod).get();
  },
  components: {
    CarouselWidget,
    InformationsForm,
  },
};
</script>

<style lang="scss" scoped>
.slide-show-section {
  &_img {
    aspect-ratio: 1920 / 680;
    min-height: 520px;
    object-fit: cover;

    @media screen and (max-width: 959.9px) {
      min-height: auto;
    }

    @media screen and (max-width: 600px) {
      aspect-ratio: 600 / 600;
    }
  }
}

.informations {
  @media screen and (max-width: 959.9px) {
    background-color: var(--v-primary-base);
  }

  @media screen and (min-width: 960px) {
    bottom: 0;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;

    &-square {
      border-radius: 20px;
      pointer-events: initial;
    }
  }
}
</style>
